import React from 'react';
import { Image, Text, TouchableOpacity } from 'react-native';
import { img_dropdown } from '../../../utils/ImagesManagementUtils';

//= ========================================================================

const OpenBoxButton = ({
  text, onPress, noPadding, cleanBackground, isBoxOpen, withSplit,
}) => {
  const getNoPaddingBackgroundColor = noPadding ? '#e2e8f0' : '#ffffff';
  const getCleanBackgroundColor = isBoxOpen ? '#e2e8f0' : '#ffffff';
  const getBackgroundColor = cleanBackground ? getCleanBackgroundColor : getNoPaddingBackgroundColor;
  const myStyles = {
    container: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      background: getBackgroundColor,
      padding: 5,
      paddingStart: 12,
      width: 170,
      border: cleanBackground && 'solid 1px #cbd5e0',
      borderRadius: cleanBackground && 4,
    },
    imageStyle: {
      width: 24,
      height: 24,
    },
  };

  return (
    <TouchableOpacity
      style={myStyles.container}
      onPress={() => {
        onPress();
      }}
    >
      <Text>{withSplit ? text.split('(')[0] : text}</Text>
      <Image
        style={myStyles.imageStyle}
        source={img_dropdown}
      />
    </TouchableOpacity>
  );
};
export default OpenBoxButton;
